import React from "react";

const Razor_CSharp_Logic = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor CSharp Logic</h1>
      <p>This is the Razor CSharp Logic page content.</p>
    </div>
  );
};

export default Razor_CSharp_Logic;
